import { QueryEntity } from '@datorama/akita';
import { State, CartStateStore } from './cart-state.store';
import { CartState } from './cart-state.model';
​
export class CartStateQuery extends QueryEntity<State, CartState> {
  constructor(protected store: CartStateStore) {
    super(store);
  }
}
